import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { ApiMultiUserInvites } from "@/legacy/ApiCallerOld";
import { useCache } from "@/Hooks/useCache";
import { Button, ButtonBlue } from "../../Button/Button";
import OtherFunctions from "../../../Helpers/OtherFunctions";
import Modal from "@shared/Components/Modal/Modal";
import ModalButtons from "@shared/Components/Modal/ModalButtons";
import ModalContent from "@shared/Components/Modal/ModalContent";
import W_TextArea from "@shared/Components/FormComponents/TextArea/W_TextArea";
import { MultiUserInvite } from "@shared/Models/Requests/MultiUserInvites";

interface AddUserModalProps {
	isOpen: boolean;
	closeModal(): void;
}

export default function AddUserModal(props: AddUserModalProps) {
	const [isLoading, setIsLoading] = useState(false);

	const cache = useCache();
	const navigate = useNavigate();

	const { handleSubmit, reset, control } = useForm<MultiUserInvite>({
		defaultValues: {
			emailsToInvite: ""
		}
	});

	async function onSubmit(data: MultiUserInvite) {

		const emails = data.emailsToInvite.split("\n");

		if (emails.length >= 25) {
			toast.error("You can only invite 25 users at a time.");
			return;
		}

		setIsLoading(true);
		const toastId = toast.loading("Sending invites.");

		const res = await ApiMultiUserInvites(data);

		setIsLoading(false);

		if (res.successful && res.data != null) {
			if (res.data == "SUCCESS") {
				toast.success("User Invite Successful.", { id: toastId });
				reset();
				props.closeModal();
			} else {
				toast.error("Invite failed (BE): " + res.data, { id: toastId });
			}
		} else if (res.formFieldErrorCode != undefined) {
			OtherFunctions.displayEmailTakenError(res, cache, navigate);
		} else {
			toast.error("Invite failed (BE): " + res.errorMsg, { id: toastId });
		}
	}

	function close() {
		reset();
		props.closeModal();
	}

	return (
		<Modal
			isOpen={props.isOpen}
			onClose={close}
			title="Invite Users"
		>
			<ModalContent>
				<p className="text-base text-start mb-6 ">
					Invite new users by email to create a portal account. You can invite up to 25 users.
					<br /><br />
					Separate each email address with a new line.
				</p>

				<W_TextArea
					control={control}
					rows={7}
					dataname="emailsToInvite"
					label="Email addresses"
					mandatory
					autoFocus
					placeholder="user1@company.com&#10;user2@company.com&#10;user3@company.com&#10;user4@company.com&#10;&#10;user5@company.com&#10;"
					maxLength={1400}
				/>
				<span className=" flex justify-end text-base text-start my-1">Max emails: 25</span>
			</ModalContent>

			<ModalButtons>
				<Button onClick={close} label="Cancel" />
				<ButtonBlue onClick={() => handleSubmit(onSubmit)()} label="Send all invites" disabled={isLoading} />
			</ModalButtons>
		</Modal>
	);
}
